import { useState } from 'react'
import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    triggeredBy: translate({ id: 'gps.eventslist.view.triggeredBy' }),
  }))

  return api
}
